<script>
import replayCard from "@/components/gameReplayAnalysis/replayCard.vue";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import { MapClientType } from "@/common/util";

import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    replayCard,
    PagenationContainer
  },
  data() {
    let defaultDate = [
      moment()
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    let ageRange = [undefined, undefined];
    const gameReplayOption = sessionStorage.getItem("gameReplayOption");
    let type = "FINE_STIMULATION_TRAINING";
    let gameId = undefined;
    let activePage = 1;
    let ageParams = {
      monthBefore: undefined,
      monthAfter: undefined,
      ageBefore: undefined,
      ageAfter: undefined
    };
    let patientName = undefined;
    if (gameReplayOption) {
      const options = JSON.parse(gameReplayOption);
      type = options.type || undefined;
      gameId = options.gameId || undefined;
      defaultDate = options.dateRange || undefined;
      activePage = options.activePage || undefined;
      ageRange = options.ageRange || [undefined, undefined];
      patientName = options.patientName || undefined;
      if (options.ageParams) {
        ageParams = {
          monthBefore: options.ageParams.monthBefore || undefined,
          monthAfter: options.ageParams.monthAfter || undefined,
          ageBefore: options.ageParams.ageBefore || undefined,
          ageAfter: options.ageParams.ageAfter || undefined
        };
      }
    }
    return {
      typeSource: [
        {
          name: "精细刺激训练",
          type: "FINE_STIMULATION_TRAINING"
        },
        {
          name: "视觉技巧训练",
          type: "VISUAL_SKILL_TRAINING"
        },
        {
          name: "同时视",
          type: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "融合视",
          type: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "立体视",
          type: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "Gabor训练",
          type: "GABOR_TRAINING"
        },
        {
          name: "对比敏感度训练",
          type: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          name: "信息提取训练",
          type: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      type: type,
      games: [],
      gameId: gameId,
      tableData: [],
      pageCount: 0,
      activePage: activePage,
      totalElements: 1,
      dateRange: defaultDate,
      needRefresh: true,
      activeGame: undefined,
      ageRange,
      ageParams,
      patientName
    };
  },
  created() {
    this.loadData("init");

    this.$nextTick(() => {
      document.addEventListener("keyup", this.onEnterForSearch);
    });
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.onEnterForSearch);
  },
  methods: {
    async loadData(init) {
      const result = await this.$http.getGameList(this.type);
      this.games = result.data ? result.data.content : [];
      if (this.games.length) {
        if (this.gameId) {
          this.activeGame = this.games.filter(o => o.id === this.gameId)[0];
        } else {
          let activeGame = this.games[0];
          this.activeGame = activeGame;
          this.gameId = activeGame.id;
        }
      }
      if (init) {
        this.loadStatistic();
      }
    },
    onSelectGameType(type) {
      if (type) {
        this.gameId = undefined;
        this.games = [];
        this.loadData();
      }
    },
    onSearch() {
      this.activePage = 1;
      if (
        this.$refs.ageRangeSelect.ageStart &&
        this.$refs.ageRangeSelect.ageEnd
      ) {
        if (
          moment(this.$refs.ageRangeSelect.ageEnd).isBefore(
            this.$refs.ageRangeSelect.ageStart
          )
        ) {
          this.ageRange = [
            this.$refs.ageRangeSelect.ageEnd.format("YYYY-MM-DD"),
            this.$refs.ageRangeSelect.ageStart.format("YYYY-MM-DD")
          ];
        } else {
          this.ageRange = [
            this.$refs.ageRangeSelect.ageStart.format("YYYY-MM-DD"),
            this.$refs.ageRangeSelect.ageEnd.format("YYYY-MM-DD")
          ];
        }
      } else if (this.$refs.ageRangeSelect.ageStart) {
        this.ageRange = [
          this.$refs.ageRangeSelect.ageStart.format("YYYY-MM-DD"),
          undefined
        ];
      } else if (this.$refs.ageRangeSelect.ageEnd) {
        this.ageRange = [
          undefined,
          this.$refs.ageRangeSelect.ageEnd.format("YYYY-MM-DD")
        ];
      }

      if (this.gameId) {
        this.activeGame = this.games.filter(o => o.id === this.gameId)[0];
      }
      if (this.$refs.ageRangeSelect) {
        this.ageParams = {
          monthBefore: this.$refs.ageRangeSelect.monthBefore || undefined,
          monthAfter: this.$refs.ageRangeSelect.monthAfter || undefined,
          ageBefore: this.$refs.ageRangeSelect.ageBefore || undefined,
          ageAfter: this.$refs.ageRangeSelect.ageAfter || undefined
        };
      }
      const gameReplayOption = {
        activePage: 1,
        gameId: this.gameId,
        type: this.type,
        dateRange: this.dateRange,
        ageRange: this.ageRange,
        ageParams: this.ageParams,
        patientName: this.patientName
      };
      const temp = JSON.stringify(gameReplayOption);
      sessionStorage.setItem("gameReplayOption", temp);
      this.loadStatistic();
    },
    async loadStatistic() {
      const params = {
        gameId: this.gameId,
        start: this.dateRange[0] ? this.dateRange[0] : undefined,
        end: this.dateRange[1] ? this.dateRange[1] : undefined,
        page: this.activePage - 1,
        birthStart: this.ageRange[0] ? this.ageRange[0] : undefined,
        birthEnd: this.ageRange[1] ? this.ageRange[1] : undefined,
        sort: "training.trainingAt,DESC",
        name: this.patientName
      };
      const result = await this.$http.gameTrainStatisticReplay(params);
      this.pageCount = result.totalPages;
      // console.log("tresult", result);
      this.tableData = result.content.map(o => {
        o.url = this.activeGame.url;
        o.icon = this.activeGame.icon;
        o.client = MapClientType(o.clientType);
        return o;
      });
      this.needRefresh = false;
      this.$nextTick(() => {
        this.needRefresh = true;
      });
    },
    onSelectValue(refName, value) {
      if (value === false) {
        this.$refs[refName].blur();
      }
    },
    onEnterForSearch(e) {
      if (e.key == "Enter") {
        this.loadStatistic();
      }
    },
    handleCurrentChange(val) {
      this.activePage = val;
      const gameReplayOption = {
        activePage: val,
        gameId: this.gameId,
        type: this.type,
        dateRange: this.dateRange,
        ageRange: this.ageRange,
        ageParams: this.ageParams,
        patientName: this.patientName
      };
      const temp = JSON.stringify(gameReplayOption);
      sessionStorage.setItem("gameReplayOption", temp);
      this.loadStatistic();
    },
    onAgeChange(value) {
      console.log("+++>>>>>>", value);
    }
  }
};
</script>
<template>
  <div class="gameReplayAnalysis">
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle">
          训练类别：
          <el-select
            size="medium"
            v-model="type"
            @change="onSelectGameType"
            @visible-change="(value) => onSelectValue('type', value)"
            class="selectInputStyle"
            ref="type"
          >
            <el-option
              v-for="typeInfo in typeSource"
              :key="typeInfo.type + typeInfo.name"
              :label="typeInfo.name"
              :value="typeInfo.type"
            />
          </el-select>
        </span>
        <span class="searchTitle">
          选择游戏：
          <el-select
            size="medium"
            v-model="gameId"
            @visible-change="(value) => onSelectValue('gameId', value)"
            class="selectInputStyle"
            filterable
            ref="gameId"
          >
            <el-option
              v-for="(game, index) in games"
              :key="index + '_gameName'"
              :label="game.name"
              :value="game.id"
            />
          </el-select>
        </span>
        <span class="searchTitle">
          姓名：
          <el-input
            size="medium"
            placeholder="患者姓名"
            v-model="patientName"
            class="selectInputStyle"
            clearable
          />
        </span>
        <span class="searchTitle">
          时段选择：
          <el-date-picker
            v-model="dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="-"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle">
          年龄段：
          <ageRangeSelect :ageParams="ageParams" ref="ageRangeSelect" @onAgeChange="onAgeChange" />
        </span>
        <el-button class="searchButton" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <div class="chartview" v-if="tableData.length > 0">
      <replayCard v-for="gamrReplay in tableData" :key="gamrReplay.trainingId" :item="gamrReplay" :gameId="activeGame.id" />
    </div>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.gameReplayAnalysis {
  padding-left: 30px;
  padding-top: 15px;

  .gameSearchForm {
    margin: 0px 0px 5px !important;
    color: rgba(89, 94, 122, 1);

    // width: 0px;
    .colStyle {
      margin-bottom: 5px;
      padding: 0 !important;
    }

    .selectInputStyle {
      width: 150px;
    }

    .searchTitle {
      padding-right: 10px;
      padding-left: 10px;
      margin-bottom: 5px;
      display: inline-block;
    }

    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }

    .searchButton {
      background-color: #00c1de;
      border-color: #00c1de;
      margin-left: 15px;
      color: #fff;
      height: 36px;
    }
  }

  .chartview {
    display: flex;
    flex-wrap: wrap;

    // justify-content: space-around;
    .statisticsCharts {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gameReplayAnalysis/index.vue